/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Cash_ProjectionInputs */

const en_nav_cash_projection = /** @type {(inputs: Nav_Cash_ProjectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cash projection`)
};

/**
* | output |
* | --- |
* | "Cash projection" |
*
* @param {Nav_Cash_ProjectionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_cash_projection = /** @type {((inputs?: Nav_Cash_ProjectionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Cash_ProjectionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_cash_projection(inputs)
});